
import {message_} from './messages.js' 
import { redirect_ } from './redirect.js';
import { options } from '../config';
const API_GATEWAY = options.form0.api

var options_ = options.form0.options

export async function GetContact(profile, uuid, idToken, success, failed) {
    const url = API_GATEWAY + "contact/" + encodeURI(profile) + "/" + encodeURI(uuid.split("/").join("|||;"))
    let header = {

    }
    if (idToken)
        header.idToken = idToken;
    await fetch(url, {
        method: "GET",
        headers: header
    })
        .then(r => r.json())
        .then(data => {
            if (data.success) {
                if (data && data.data && data.data.onetime) {
                    getSignedURL(data.data.url,(d_)=>{
                        success(d_)
                    })
                } else {
                    success(data.data)
                } 
            } else {
                failed(data)
            }
        })
        .catch(error => {
            failed(error)
        })
}

function getSignedURL(url,cb) {
    console.log("Signed URL")
    fetch(url)
    .then(r => r.json())
    .then(data => {
        m(data)
        return cb(data)
    })
}


export async function PostContact(data, idToken, success, failed) {
    if (idToken)
        data.idToken = idToken
    if (!data.profile) {
        failed({ error: "Missing Profile" })
    }
    if (!data.form) {
        failed({ error: "Missing Ruleset" })
    }
    if(!data.contact_uuid)
            data.contact_uuid = generateUUID
    const url = API_GATEWAY + "contact"
    await fetch(url, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(r => r.json())
    .then(data => {
        if (data.success) {
            if (data && data.data && data.data.onetime) {
                getSignedURL(data.data.url,(d_)=>{
                    success(d_)
                })
                    
            } else {
                m(data)
                success(data.data)
            }
        } else {
            m(data)
            failed(data)
        }
    })
    .catch(error => {
        failed(error)
    })
}


function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};

//Message Management
const m = (result)=>{
    if(result.errorMessage){
        console.error(result.errorMessage)
      //  throw new Exception(result.errorMessage)
    }
    if(result.errorCode){
        switch(result.errorCode){
            case 700:
                //Reauthenticate here
                if(options_.redirectOnAuth)
                    redirect_.set(options_.redirectOnAuth);
                break;
            default:
                break;
        }
    }
    if(result.success){
        const app_metadata = (result.data || {}).app_metadata || {};
        if(app_metadata.redirect&&options_.redirect){      
                redirect_.set(app_metadata.redirect);
        }
        if (app_metadata.message&&options_.messages) {
            message_.set(app_metadata.message)
        }
        if (app_metadata.error&&options_.messages) {
            message_.set(app_metadata.message)
        }
        if (app_metadata.secret&&options_.messages) {
            message_.set(app_metadata.message)
        }
    }else{
        if(result.message&&options_.messages){
            message_.set(result.message)
       //     throw new Exception(result.message)
        }
        const app_metadata = (result.data || {}).app_metadata || {};

        if (app_metadata.error&&options_.messages) {
            message_.set(app_metadata.error)
        }
    }
     
        
}
